import React, { Component } from 'react'
import { connect } from 'react-redux'
import Button from '../components/uiKit/Button'
import {dismissBackToSchoolModal,permenantlyDismissBackToSchoolModal} from '../actions/backToSchoolModal'
import {getUserSegment} from '../utils/getUserSegment'
import {switchPlan,upgradeService} from '../actions/service'
import {showNotification} from '../actions/notifications'
import {getPaymentErrorMessage} from '../utils/getPaymentErrorMessage'
import {fetchUpcomingInvoice} from '../actions/billing'
import {fetchBilling} from '../actions/billing'
import FeatureModalSelectControl from '../components/featureModals/FeatureModalSelectControl'
import FeatureModalSelectControlGroup from '../components/featureModals/FeatureModalSelectControlGroup'

class BackToSchoolModal extends Component {

	constructor(){
		super()				

		this.handleBackgroundClick=this.handleBackgroundClick.bind(this)
		this.goToUpgradePaymentPage=this.goToUpgradePaymentPage.bind(this)

	}
 


	handleBackgroundClick(e){
		if (e.target === e.currentTarget) this.props.dismissBackToSchoolModal() //close modal is click outside modal
	}
	

	goToUpgradePaymentPage(){
		window.location.hash='upgrade-payment'
		this.props.dismissBackToSchoolModal()
	}


	componentDidMount(){
		if(window.analytics){
			const userSegment=getUserSegment()
			if(userSegment==='churnedPro'){
				window.analytics.page('BackToSchoolModal',{couponName:'BTS2019-ChurnedPro'})
			}else{
				window.analytics.page('BackToSchoolModal',{couponName:'	BTS2019-ActiveMonthlyPro'})

			}
		}
	}
	




  
	
	render() {
		const userSegment=getUserSegment()
		const {openedFromContextBadge,billingInfo}=this.props

		

		if(userSegment==='churnedPro'){


			const billingInfoBrand = billingInfo? billingInfo.brand:null
			const billingInfoLast4 =billingInfo? billingInfo.last4:null

			const cardInfoString=`${billingInfoBrand} •••• •••• •••• ${billingInfoLast4}`
  		
			const {annualSubmitLoading,monthlySubmitLoading} = this.props


			return (
				<div className='backToSchoolModalContainer' onClick={this.handleBackgroundClick}>				

					<div className='backToSchoolModal backToSchoolModal--churnedPro marketing'>

						<div className='backToSchoolModal-limitedOfferSash'>
							Last Chance
							<svg width="272" height="34" viewBox="0 0 272 34">
							  <path d="M3.32614207,0 L268.75475,0 C270.411604,-2.51733549e-14 271.75475,1.34314575 271.75475,3 C271.75475,3.53487834 271.611747,4.06003044 271.340553,4.52106038 L264.894741,15.4789396 C264.342478,16.417787 264.342478,17.582213 264.894741,18.5210604 L271.340553,29.4789396 C272.180611,30.907039 271.70391,32.7457442 270.27581,33.5858026 C269.814781,33.8569967 269.289628,34 268.75475,34 L3.16953903,34 C1.51268479,34 0.169539035,32.6568542 0.169539035,31 C0.169539035,30.4779192 0.305784987,29.9648763 0.564809609,29.5115832 L7.12389774,18.033179 C7.66460819,17.0869357 7.64962607,15.921883 7.08476181,14.989857 L0.760548575,4.55490515 C-0.0982018261,3.13796699 0.35429876,1.29315691 1.77123692,0.434406505 C2.24010688,0.150242893 2.77788301,-7.87464864e-16 3.32614207,0 Z"/>
							</svg>

						</div>
						
						<div className='backToSchoolModal-h1'>
							<b>Save 45%</b> with an annual Plickers Pro subscription today
						</div>												

						<div className='backToSchoolModal-h3'>
							We can’t wait to show you what’s coming to Pro in 2019/2020.
						</div>

						<div className='backToSchoolModal-h2'>
							Our back-to-school offer: <br/>
							Upgrade today to an annual plan and save $50.
						</div>
											
						<div className='backToSchoolModal--churnedPro-upgradeBtnContainer'>
							<button disabled={monthlySubmitLoading || annualSubmitLoading} className='btn btn--blue btn--xLarge backToSchoolModal--churnedPro-upgradeBtn' onClick={()=>{this.props.upgradePlan(process.env.REACT_APP_STRIPE_YEARLY_PLAN_ID)}}>
								{!annualSubmitLoading &&
									<React.Fragment>
										<div className='backToSchoolModal--churnedPro-upgradeBtn-primary'>
											Upgrade to Annual
										</div>
										<div className='backToSchoolModal--churnedPro-upgradeBtn-sub'>
											$57.50 / year
										</div>
									</React.Fragment>
								}
								{annualSubmitLoading &&
										<div className='backToSchoolModal--churnedPro-upgradeBtn-submitLoading'>							 								 	
										 	<div className='backToSchoolModal--churnedPro-upgradeBtn-submitLoading-spinnerContainer'>
										 		<div className='backToSchoolModal--churnedPro-upgradeBtn-submitLoading-spinner' />
										 	</div>
										</div>
								}

							</button>

							<button disabled={monthlySubmitLoading || annualSubmitLoading}  className='btn btn--blue btn--xLarge backToSchoolModal--churnedPro-upgradeBtn' onClick={()=>{this.props.upgradePlan(process.env.REACT_APP_STRIPE_MONTHLY_PLAN_ID)}}>								
								{!monthlySubmitLoading &&
									<React.Fragment>
										<div className='backToSchoolModal--churnedPro-upgradeBtn-primary'>
											Upgrade to Monthly
										</div>
										<div className='backToSchoolModal--churnedPro-upgradeBtn-sub'>
											$8.99 / month
										</div>
									</React.Fragment>
								}
								{monthlySubmitLoading &&
										<div className='backToSchoolModal--churnedPro-upgradeBtn-submitLoading'>							 								 	
										 	<div className='backToSchoolModal--churnedPro-upgradeBtn-submitLoading-spinnerContainer'>
										 		<div className='backToSchoolModal--churnedPro-upgradeBtn-submitLoading-spinner' />
										 	</div>
										</div>
								}

							</button>

						</div>

						<Button label="I'm happy with the free plan" size='xLarge' color='white' onClickFunction={this.props.dismissBackToSchoolModal}/>

						<div className='backToSchoolModal--churnedPro-currentCardContainer' >
							If you upgrade today, we’ll use {cardInfoString}. <span onClick={this.goToUpgradePaymentPage} className='backToSchoolModal--churnedPro-currentCardContainer-link'>Upgrade with a different card.</span>
						</div>


						<div className='backToSchoolModal-smallprint'>
							If you upgrade now, you will be charged immediately. <br/>
							Annual savings at discounted rate vs. monthly are $50.38 (46.7%) over 12 months.<br/>
							Discounted rate continues through 12 months. <br/>
						</div>
						
					</div>
								
				</div>								
			)
		}
		else if(userSegment==='activeMonthlyPro'){
			return (
				<div className='backToSchoolModalContainer' onClick={this.handleBackgroundClick}>				

					<div className='backToSchoolModal backToSchoolModal--activeMonthly marketing'>

						<div className='backToSchoolModal-limitedOfferSash'>
							Last Chance
							<svg width="272" height="34" viewBox="0 0 272 34">
							  <path d="M3.32614207,0 L268.75475,0 C270.411604,-2.51733549e-14 271.75475,1.34314575 271.75475,3 C271.75475,3.53487834 271.611747,4.06003044 271.340553,4.52106038 L264.894741,15.4789396 C264.342478,16.417787 264.342478,17.582213 264.894741,18.5210604 L271.340553,29.4789396 C272.180611,30.907039 271.70391,32.7457442 270.27581,33.5858026 C269.814781,33.8569967 269.289628,34 268.75475,34 L3.16953903,34 C1.51268479,34 0.169539035,32.6568542 0.169539035,31 C0.169539035,30.4779192 0.305784987,29.9648763 0.564809609,29.5115832 L7.12389774,18.033179 C7.66460819,17.0869357 7.64962607,15.921883 7.08476181,14.989857 L0.760548575,4.55490515 C-0.0982018261,3.13796699 0.35429876,1.29315691 1.77123692,0.434406505 C2.24010688,0.150242893 2.77788301,-7.87464864e-16 3.32614207,0 Z"/>
							</svg>

						</div>
						
						<div className='backToSchoolModal-h1'>
							<b>Save 45%</b> on your current <br/>Plickers Pro subscription today
						</div>												

						<div className='backToSchoolModal-h3'>
							We can’t wait to show you what’s coming to Pro in 2019/2020.
						</div>

						<div className='backToSchoolModal-h2'>
							Our back-to-school offer: <br/>
							Switch to an annual plan today and save $50.
						</div>

						<Button label='Switch to an annual plan and save 45%' size='xLarge' color='blue' submitLoading={this.props.switchPlanSubmitLoading} onClickFunction={this.props.switchToYearlyPlan}/>
							
						<Button label='No thanks, I’ll stay on my current plan' size='xLarge' color='white' onClickFunction={this.props.dismissBackToSchoolModal}/>

						{openedFromContextBadge &&
							<FeatureModalSelectControlGroup>
								<FeatureModalSelectControl checked={this.props.backToSchoolModalPermenantlyDismissed} onClick={this.props.permenantlyDismissBackToSchoolModal} checkbox label='Do not show me this offer again' />
							</FeatureModalSelectControlGroup>						 
						}


						<div className='backToSchoolModal-smallprint'>
							If you switch to an annual plan, at the start of your next billing period you will be charged $57.50. <br/>
							Annual savings vs. monthly are $50.38 (46.7%). <br/>
							Discounted rate continues through 12 months. <br/>
						</div>



						
					</div>
				</div>								
			)
		}else return null
	}
}







class BackToSchoolModalContainer extends Component {

	constructor(){
		super()	
		this.shouldShowBackToSchoolModal=this.shouldShowBackToSchoolModal.bind(this)
		this.switchToYearlyPlan=this.switchToYearlyPlan.bind(this)
		this.handleUpgrade=this.handleUpgrade.bind(this)

		this.state={
			upgradeError:null,
			switchPlanSubmitLoading:false,
			annualSubmitLoading:false,
			monthlySubmitLoading:false

		}       




	}


	shouldComponentUpdate(nextProps){
		if(this.props.meta && nextProps.meta && this.props.meta.sharingOptedIn!==nextProps.meta.sharingOptedIn){
			return false
		}else return true
	}



	switchToYearlyPlan(){
		this.setState({switchPlanSubmitLoading:true})

		if(window.analytics){
			window.analytics.track('Claim Back To School Modal Coupon',{
				couponCode:process.env.REACT_APP_DEFAULT_COUPON_CODE,
				action:'switchToYearly'
			})
		}



		const newPlan=process.env.REACT_APP_STRIPE_YEARLY_PLAN_ID
		const coupon=process.env.REACT_APP_DEFAULT_COUPON_CODE	

		this.props.switchPlan(newPlan,coupon).then(()=>{
			this.props.dismissBackToSchoolModal()
			this.props.showNotification('',"You've switched to an annual Plicker Pro plan and saved 45%",'default')

		})
	}



	handleUpgrade(plan){
		this.setState({submitLoading:true})

		let coupon=null
		if(plan===process.env.REACT_APP_STRIPE_YEARLY_PLAN_ID){
			coupon=process.env.REACT_APP_DEFAULT_COUPON_CODE
			if(window.analytics){
				window.analytics.track('Claim Back To School Modal Coupon',{
					couponCode:process.env.REACT_APP_DEFAULT_COUPON_CODE,
					action:'upgradeToYearly'
				})
			}
			this.setState({annualSubmitLoading:true})
		}else{
			if(window.analytics){
				window.analytics.track('Claim Back To School Modal Coupon',{
					couponCode:null,
					action:'upgradeToMonthly'
				})
			}
				this.setState({monthlySubmitLoading:true})
		}

		return this.props.upgradeService({'plan':plan,'coupon':coupon}).then(()=>{
			this.setState({upgradeSuccessful:true,upgradeError:false})
			this.props.fetchBilling()
			this.props.fetchUpcomingInvoice()
			this.props.showNotification('','Successfully upgraded to Plickers Pro','default')
			this.setState({monthlySubmitLoading:false,annualSubmitLoading:false})
			return

		})
			.catch(error => {
				let errorMessage='Please try again. If the problem persists, contact support.'
				if(error.response.status===402){
					const response=error.response
					return response.text().then(function (text) {
						errorMessage=getPaymentErrorMessage(text)
						this.setState({upgradeError:errorMessage})
						return 'error'
					}.bind(this))
					
				}else{
					this.setState({upgradeError:errorMessage})
					return 'error'
				}
			})


	}






	shouldShowBackToSchoolModal(){
		let isDiscountPeriod=false
		const discountPeriodStartDate = process.env.REACT_APP_DEFAULT_COUPON_START_DATE
		const discountPeriodEndDate = process.env.REACT_APP_DEFAULT_COUPON_END_DATE
		const currentDate = new Date()
		const startDate = new Date(discountPeriodStartDate)
		const endDate = new Date(discountPeriodEndDate)

		if(startDate<currentDate && endDate > currentDate){
		   isDiscountPeriod=true
		} 

		if(!isDiscountPeriod){
			return false
		}
		else{
			const userSegment=getUserSegment()
			const {meta}=this.props
			if(this.props.backToSchoolModal.dismissed|| (meta && !meta.sharingOptedIn)){
				return false
			}
			else{
				if(userSegment==='churnedPro' || userSegment==='activeMonthlyPro'){
					return true
				}
				else return false
			}
	}
		
	}
	
	render() {

 

		if(this.shouldShowBackToSchoolModal() ){
			let email
			let fullName=''
			if(this.props.user){
				email=this.props.user.email
				if(this.props.user.firstName){
					fullName=`${this.props.user.firstName} ${this.props.user.lastName}`
				}
			}


			return 	<BackToSchoolModal 
						dismissBackToSchoolModal={this.props.dismissBackToSchoolModal} 
						switchToYearlyPlan={this.switchToYearlyPlan}
						billingInfo={this.props.billing}
						upgradePlan={this.handleUpgrade}
						email={email}
						fullName={fullName}
						upgradeError={this.state.upgradeError}	
						openedFromContextBadge={this.props.backToSchoolModal.openedFromContextBadge}
						permenantlyDismissBackToSchoolModal={this.props.permenantlyDismissBackToSchoolModal}
						backToSchoolModalPermenantlyDismissed={this.props.backToSchoolModal.permenantlyDismissed}
						switchPlanSubmitLoading={this.state.switchPlanSubmitLoading}
						annualSubmitLoading={this.state.annualSubmitLoading}
						monthlySubmitLoading={this.state.monthlySubmitLoading}



				/>
		
		}
		else return null
	}
}





export default connect(
	(state) => ({
		service:state.service,
		meta:state.meta,
		backToSchoolModal:state.backToSchoolModal,
		billing:state.billing,
		user:state.user
	
	}),
	{ permenantlyDismissBackToSchoolModal,dismissBackToSchoolModal,switchPlan,showNotification,upgradeService,fetchUpcomingInvoice,fetchBilling}
)(BackToSchoolModalContainer)






// WEBPACK FOOTER //
// ./src/containers/BackToSchoolModalContainer.js